import React, { useEffect } from "react";
import "../../../../../Assets/Styles/UserGuide.scss";

const BookmarkedItemsGuide = (props) => {
  useEffect(() => {
    const savedOnly = document.getElementById("saved-only");
    const guide = document.getElementById("bookmarked-items-guide");

    if (savedOnly) {
      savedOnly.classList.add("guide-is-open");
    }
    
    if (guide) {
      guide.scrollIntoView();
    }

    return () => {
      const savedOnlyCleanup = document.getElementById("saved-only");
      if (savedOnlyCleanup) {
        savedOnlyCleanup.classList.remove("guide-is-open");
      }
    };
  }, []);

  const translateText = (LabelId) => {
    // Safety check to prevent blank screen
    if (!props.LangData || !Array.isArray(props.LangData)) {
      return LabelId; 
    }

    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj && Obj[Filter] === Keyword;
    });

    // Use optional chaining (?.) to prevent crashing if label is missing
    return Label[0]?.label_value || LabelId;
  };

  const toggleNextGuide = () => {
    props.ToggleNextDialog();
  };

  const togglePreviousGuide = () => {
    props.TogglePreviousDialog();
  };

  return (
    <div
      className="guide-dialog bookmarked-items-guide"
      id="bookmarked-items-guide"
    >
      <i className="feather-x" onClick={() => props.CloseGuide()}></i>
      <p className="dialog-text">
        {translateText("walkthrough_homepage_bookmarked_items")}
      </p>
      <section className="dialog-footer">
        <div className="steps-navs back" onClick={() => togglePreviousGuide()}>
          <i className="feather-arrow-left"></i>
          <p>{translateText("back")}</p>
        </div>
        <div className="indicators">
          <>
            {props.GuideHasAdditionalStep ? (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(i)}
                    className={
                      i === 3 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i)}
                  ></span>
                ))}
              </>
            ) : (
              <>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((Item, i) => (
                  <span
                    onClick={() => props.JumpToStep(Item)}
                    className={
                      i === 2 ? "step-circle active-circle" : "step-circle"
                    }
                    id={"circle-" + parseInt(i + 1)}
                  ></span>
                ))}
              </>
            )}
          </>
        </div>
        <div className="steps-navs next" onClick={() => toggleNextGuide()}>
          <p>{translateText("next")}</p>
          <i className="feather-arrow-right"></i>
        </div>
      </section>
    </div>
  );
};

export default BookmarkedItemsGuide;
